import clsx from 'clsx';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../../../Translations';
import { PublicNameProgramFamilyShareUrl } from '../../../../../../../../../Types';
import InviteParticipantStore from '../../../../../Store';
import SubmitButton from '../../../../../SubmitButton';

export interface Props {
  store: InviteParticipantStore;
  activationsRemaining: Maybe<number>;
  shareUrl: PublicNameProgramFamilyShareUrl;
}

const nextStep = (store: InviteParticipantStore, shareUrl: PublicNameProgramFamilyShareUrl) => {
  shareUrl.shareUrl.payload.programInstanceOptions.onDemand
    .do((onDemandInstance) => store.inviting([onDemandInstance.id]))
    .elseDo(store.selectingDates);
};

function NextButton({ store, activationsRemaining, shareUrl }: Props) {
  return activationsRemaining
    .map(() => <SubmitButton onClick={() => nextStep(store, shareUrl)} buttonText={'Next'} />)
    .getOrElse(() => (
      <div
        className={clsx(
          'pointer-events-none rounded-md bg-gray-500 text-white px-3 py-2 text-sm w-24 text-center mt-4',
        )}
      >
        <T kind="Next" />
      </div>
    ));
}

export default observer(NextButton);
